module.exports = window.SPAUI;